import React from "react";
import "./WhyChooseUs.css";
import teamImage from '../../img/about1.jpg';


export default function WhyChooseUs() {
  const stats = [
    { number: "5+", description: "With 5 years of experience, we have earned numerous awards." },
    { number: "3+", description: "We have 3 offices in three different places." },
    { number: "15+", description: "We have a team of over 15 certified full-time professionals." },
    { number: "254+", description: "We have successfully implemented over 254 projects." },
  ];

  return (
    <>
    <div className="why">
    <h1>WHY CHOOSE US?</h1>
      <p className="why-subtitle">
        Tailored to you, we create custom software specifically designed to meet your unique business needs.
      </p>
      <hr />

      <div className="why-container">
  <div className="why-content">
    <div className="info">
      <p>
        We pride ourselves on delivering high-quality custom software solutions that drive business growth and success.
        You gain a trusted partner who is dedicated to understanding your unique requirements and delivering innovative,
        secure software tailored to your needs.
      </p>
      <button className="about-btn">ABOUT US</button>
    </div>

    {/* Vertical line between Info and Image */}
    <div className="vertical-line"></div>

    <div className="image-section">
      <img src={teamImage} alt="Team Collaboration" />
    </div>

    {/* Vertical line between Image and Stats */}
    
    <div className="stats-section">
      {stats.map((stat, index) => (
        <div key={index} className="stat-card">
          <div className="stat-header">
                    <h2>{stat.number}</h2>
                    <div className="arrow">↗</div>
                    </div>
          <p>{stat.description}</p>
        </div>
      ))}
    </div>
  </div>
</div>

</div>
<hr />
</>
  );
}
